import React from "react";
import '../../styles/FeatureUpdates.css';
import hideShowIcon from "../../img/features-hide-show.svg";
import hideShowPic from "../../img/features-hide-show.png";
import hotspotIcon from "../../img/features-hotspot.svg";
import hotspotPic from "../../img/features-image-hotspot.png";
import screenBreakIcon from "../../img/features-split-icon.svg";
import screenBreakPic1 from "../../img/features-break-1.png";
import screenBreakPic2 from "../../img/features-break-2.png";
import pdfImportIcon from "../../img/features-import.svg";
import pdfImportPic from "../../img/features-pdf-import.png";
import HeaderContainer from "../containers/HeaderContainer";

class FeatureUpdates extends React.Component {
  render() {
    return (
      <div>
        <HeaderContainer loginNotRequired/>
        <div className={"page-container__features"}>

          {/* fifth section */}
          <div>
            <div className={"section"}>
              <div className={"verticalLine"}>
                <div className={"icon"}>
                  <img src={pdfImportIcon} alt="PDF Import"></img>
                </div>
              </div>
              <div className={"sectionDetails"}>
                <h2 className={"bold"}>PDF Import</h2>
                <p className={"eight-top eight-bottom"}>Feb 20, 2019</p>
                <p className={"eight-top"}>Are you still delivering PDF content to your learners
                  that is static, difficult to view on mobile devices, incompatible with assistive
                  technologies, and more tailored to a print experience than digital consumption?
                  Now you can take that PDF content, upload it into Studio, and re-purpose the text
                  and images in a new EPUB 3 file that can be enhanced with a wide range of
                  interactive content--video, audio, interactive images, interactive questions, and
                  hide/show text blocks.
                </p>
                <p className={"eight-top"}>NOTE: Given the high variability of PDF files, content
                  extraction results will vary.
                </p>
                <img src={pdfImportPic}
                     alt={"A mouse is hovering over a clickable card that says 'Import. Import a "
                          + "PDF. Learn More button with external link'"}></img>
              </div>
            </div>
          </div>

          {/* fourth section */}
          <div>
            <div className={"section"}>
              <div className={"verticalLine"}>
                <div className={"icon"}>
                  <img src={screenBreakIcon} alt="Insert Screen Break Feature"></img>
                </div>
              </div>
              <div className={"sectionDetails"}>
                <h2 className={"bold"}>Screen Break and Screen Merge</h2>
                <p className={"eight-top eight-bottom"}>Feb 5, 2019</p>
                <p className={"eight-top"}>After you’ve entered your content into Studio, you may
                  change your mind about the amount of content displayed on each screen. With Screen
                  Break and Screen Merge, you now have the tools you need to easily make these
                  adjustments.
                </p>
                <p className={"eight-top"}>While viewing the table of contents, select <span style={{fontWeight: 'bold'}}>Merge
                  with Previous</span> to append that screen’s contents to the previous screen:
                </p>
                <img src={screenBreakPic1}
                     alt={"There is a table of contents. A row is highlighted and the menu is open "
                          + "for that row. The open menu has the following options: Edit Screen "
                          + "Info, Duplicate Screen, Delete Screen, and Merge with Previous. Merge "
                          + "with Previous is highlighted."}></img>
                <p className={"eight-top"}>When viewing a screen, click the <span style={{fontWeight: 'bold'}}>Screen Break</span> button
                  to move all subsequent blocks to a new screen:
                </p>
                <img src={screenBreakPic2}
                     alt={"There are two interactive blocks in the editor. The mouse is shown "
                          + "hovering between the two interactive blocks on top of the split screen"
                          + "icon. On hover, the tooltip says 'Insert Screen Break.'"}></img>
              </div>
            </div>
          </div>

          {/* third section */}
          <div>
            <div className={"section"}>
              <div className={"verticalLine"}>
                <div className={"icon"}>
                  <img src={pdfImportIcon} alt="PDF Import"></img>
                </div>
              </div>
              <div className={"sectionDetails"}>
                <h2 className={"bold"}>PDF Import</h2>
                <p className={"category bold eight-top"}>COMING SOON MARCH 2019</p>
                <p className={"eight-top eight-bottom"}>Jan 20, 2019</p>
                <p className={"eight-top"}>Soon you’ll be able to upload your own PDF file into
                  Studio for the extraction
                  of text and images into Studio blocks. Once the content is in Studio, you can add
                  interactivity,
                  optimize the content for a digital experience, and publish as an EPUB 3 file.
                  You’ll gain all the great
                  benefits of the EPUB 3 format: Accessibility, responsive design on mobile devices,
                  and a full range of
                  interactivity. NOTE: Given the high variability of PDF files, content extraction
                  results will vary.</p>
              </div>
            </div>
          </div>

          {/* second section */}
          <div>
            <div className={"section"}>
              <div className={"verticalLine"}>
                <div className={"icon"}>
                  <img src={hideShowIcon} alt="Hide/Show Block"></img>
                </div>
              </div>
              <div className={"sectionDetails"}>
                <h2 className={"bold"}>Hide/Show Block</h2>
                <p className={"eight-top eight-bottom"}>Dec 10, 2018</p>
                <p className={"eight-top"}>Create ebook pages that are less overwhelming with the
                  new hide/show block.
                  This block allows you to add content that is hidden behind a content bar until
                  students click or tap to
                  reveal the additional information. Once revealed, students can click or tap to
                  collapse the expanded panel.</p>
                <img src={hideShowPic}
                     alt="An example of how a Hide/Show accordion functions. You can click
                     on the accordion to expand or collapse it."></img>
              </div>
            </div>
          </div>

          {/* first section */}
          <div>
            <div className={"section"}>
              <div className={"verticalLine"}>
                <div className={"icon"}>
                  <img src={hotspotIcon} alt="Hotspot Block"></img>
                </div>
              </div>
              <div className={"sectionDetails"}>
                <h2 className={"bold"}>Image Hotspot Block</h2>
                <p className={"eight-top eight-bottom"}>Dec 3, 2018</p>
                <p className={"eight-top"}>Create images with hotspots that students tap or click to
                  reveal more
                  information about the labeled item or region of the image.</p>
                <img src={hotspotPic}
                     alt="An example of how a Hotspot Block functions. You can click
                     anywhere there is a pin to reveal tooltips with more information."></img>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default FeatureUpdates;
